import {Button} from 'primereact/button'
import {useCallback, useRef} from 'react'
import NextOfKinForm from '../next-of-kin/NextOfKinForm'

const StyledTitle = ({
    title = '',
    colorClass = '',
    icon,
    description,
    children,
    showAdd = false,
}) => {
    const formRef = useRef(null)

    const handleAddNew = useCallback(() => {
        formRef.current?.showForm()
    }, [])

    return (
        <div className="py-2">
            {' '}
            <div className="flex  border-round justify-content-between align-items-center  flex-wrap ">
                <div
                    className={`flex align-items-center gap-2 ${
                        colorClass ? colorClass : 'text-teal-700'
                    }`}>
                    {icon && <span className="styled-title-icon">{icon}</span>}
                    {title && (
                        <h5
                            className={`font-bold m-0 py-2 text-center md:text-left`}>
                            {title}
                        </h5>
                    )}
                </div>

                <div className="flex">
                    {children ? <div>{children}</div> : null}
                    {!!showAdd && (
                        <div>
                            <Button
                                label="Add New"
                                icon="pi pi-plus"
                                onClick={handleAddNew}
                            />
                        </div>
                    )}
                </div>
            </div>
            {description && <p className="text-base px-1">{description}</p>}
            <NextOfKinForm ref={formRef} />
        </div>
    )
}

export default StyledTitle
